var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center"},[_c('v-img',{staticStyle:{"margin":"auto"},attrs:{"contain":"","max-height":"70px","src":_vm.LogoSB,"max-width":"400"}}),_c('br')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }